import { DestructByKey } from '@/common/types/types'
import * as MENU_ICONS from '@/components/svg/Icons/Menu'

const ICONS: DestructByKey<React.FC> = {
    'dashboard': MENU_ICONS.dashboard,
    'settings': MENU_ICONS.settings,
}

export default ICONS